import React from 'react';

import Header from '../containers/Header.jsx';
import Navigator from '../containers/Navigator.jsx';
import Footer from '../containers/Footer.jsx';
import Text from '../simple_components/Text.jsx';

import '../styles/Cataloghi.scss';

function Cataloghi(props){
    return(
        <>
            <Header setLanguage={props.setLanguage} {...props.header} />
            <Navigator {...props.navigator} />
            <div id={props.id} className={props.className}>
                <Text {...props.text[0]} />
                <Text {...props.text[1]} />
            </div>
            <Footer />
        </>
    );
}

export default Cataloghi;